package com.patronat.top.library.media.di

import com.patronat.top.library.media.data.MediaRepositoryImpl
import com.patronat.top.library.media.data.remote.MediaApi
import com.patronat.top.library.media.domain.repository.MediaRepository
import com.patronat.top.library.media.domain.usecase.UploadImageUseCase
import org.koin.dsl.module

val mediaModule = module {

    single {
        MediaApi(
            authClient = get()
        )
    }
    single<MediaRepository> {
        MediaRepositoryImpl(
            api = get()
        )
    }

    factory {
        UploadImageUseCase(
            repository = get(),
            dispatcher = get(),
        )
    }
}